module.exports = __webpack_public_path__ + "img/default_pink.3f87e9df.png";